module.exports = __webpack_public_path__ + "static/media/back-icon.583cc005.svg";